import { DIRECT_MESSAGE_TYPES, REDUX_ACTIONS, GAME_ID } from '../../data/constants';

const initState = {
  isOverlayEnabled: false,
  isVisible: false,
  type: DIRECT_MESSAGE_TYPES.INFO,
  messageContext: null,
  text: 'This is a default message',
  buttonText: 'Go Back',
};

const screenReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_UP_DIRECT_MESSAGE:
      return {
        ...state,
        isOverlayEnabled: true,
        type: payload.type,
        messageContext: payload.messageContext,
        text: payload.message,
        buttonText: payload.buttonText,
      };

    case REDUX_ACTIONS.HIDE_DIRECT_MESSAGE:
      return {
        ...state,
        isVisible: false,
      };

    case REDUX_ACTIONS.SHOW_DIRECT_MESSAGE:
      return {
        ...state,
        isVisible: true,
      };

    case REDUX_ACTIONS.SET_IS_OVERLAY_ENABLED:
      return {
        ...state,
        isOverlayEnabled: payload,
      };

    default:
      return state;
  }
};

export default screenReducer;
